// Single source of truth for supported languages. `country` is the ISO code
// country-flag-icons uses for the SVG flag.
export const LANGUAGES = [
  { code: "en", label: "English", country: "GB" },
  { code: "fr", label: "Français", country: "FR" },
  { code: "es", label: "Español", country: "ES" },
  { code: "de", label: "Deutsch", country: "DE" },
  { code: "it", label: "Italiano", country: "IT" },
];

export const SUPPORTED = LANGUAGES.map((l) => l.code);
export const FALLBACK = "en";

// The User Manual is a set of static pages (one per language); return the one
// matching the given UI language, falling back to English.
export function manualHref(language) {
  const lang = ["fr", "de", "es", "it"].find((l) => (language || "").startsWith(l));
  return lang ? `/manual-${lang}.html` : "/manual.html";
}
